function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import cn from "classnames";
import "../../styles/ui/button.scss";
export const ButtonTypes = {
  SUBMIT: "submit"
};
const Button = /*#__PURE__*/React.forwardRef(({
  className,
  disabled = false,
  name,
  text,
  type = ButtonTypes.SUBMIT,
  ...props
}, ref) => {
  return /*#__PURE__*/React.createElement("button", _extends({
    className: cn("otrl-ui__button", {
      "otrl-ui__button--disabled": disabled
    }, className),
    disabled: disabled,
    name: name,
    ref: ref,
    type: type
  }, props), text);
});
export default Button;